import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Checkbox,
  Col,
  Icon,
  Modal,
  ModalFooter,
  Row,
  TextField,
  Tooltip,
} from '@folio/stripes-components';
import { FormattedMessage, useIntl } from 'react-intl';
import { range } from 'lodash';
import { BiSolidSelectMultiple } from 'react-icons/bi';

function SelectBatchModal({
  onClose,
  open,
  isFullScreen,
  setSelectedItems,
  //   fields,
  goToIndexFunc,
}) {
  const [indexFrom, setIndexFrom] = useState(null);
  const [indexTo, setIndexTo] = useState(null);
  const [addToSelected, setAddToSelected] = useState(false);
  const intl = useIntl();

  const onCloseBatchModal = () => {
    setIndexFrom(null);
    setIndexTo(null);
    onClose();
  };

  const onSelectBatch = () => {
    const itemsRange = range(Number(indexFrom) - 1, Number(indexTo) - 1 + 1, 1);

    if (addToSelected) {
      setSelectedItems((prev) => [...prev, ...itemsRange]);
    } else {
      setSelectedItems(itemsRange);
    }
    goToIndexFunc(Number(indexFrom));
    onCloseBatchModal();
  };

  const renderFooter = () => {
    return (
      <ModalFooter>
        <Button
          id="select-batch-items-modal-btn"
          buttonStyle="primary"
          onClick={() => onSelectBatch()}
          disabled={!indexFrom || !indexTo || indexFrom === indexTo}
        >
          <FormattedMessage
            id="ui-plugin-inventory-templates.buttons.selectBatchItems"
            defaultMessage="Select batch"
          />
        </Button>
        <Button
          id="confirm-delete-item-modal-cancel-btn"
          onClick={() => onCloseBatchModal()}
        >
          <FormattedMessage
            id="ui-plugin-inventory-templates.buttons.cancel"
            defaultMessage="Cancel"
          />
        </Button>
      </ModalFooter>
    );
  };

  const renderSelectBatch = () => {
    return (
      <>
        <Row>
          <Col xs={12}>
            <Checkbox
              value={addToSelected}
              onChange={(e) => setAddToSelected(e.target.checked)}
              checked={addToSelected}
              label={
                <FormattedMessage
                  id="ui-plugin-inventory-templates.selectbatchItemsModa.addToSelected"
                  defaultMessage="Add to selected items"
                />
              }
              onMouseDown={(e) => e.preventDefault()}
            />
          </Col>
        </Row>
        <br />
        <Row>
          <Col xs={6}>
            <TextField
              label={
                <FormattedMessage
                  id="ui-plugin-inventory-templates.selectbatchItemsModal.fromLabel"
                  defaultMessage="From"
                />
              }
              value={indexFrom}
              onChange={(e) => setIndexFrom(e.target.value)}
              hasClearIcon={false}
              placeholder={intl.formatMessage({
                id: 'ui-plugin-inventory-templates.selectbatchItemsModal.fromFeild.placeholder',
                defaultMessage: 'Select start index',
              })}
              type="number"
              marginBottom0
              required
            />
          </Col>
          <Col xs={6}>
            <TextField
              label={
                <FormattedMessage
                  id="ui-plugin-inventory-templates.selectbatchItemsModal.toLabel"
                  defaultMessage="To"
                />
              }
              value={indexTo}
              onChange={(e) => setIndexTo(e.target.value)}
              hasClearIcon={false}
              placeholder={intl.formatMessage({
                id: 'ui-plugin-inventory-templates.selectbatchItemsModal.toFeild.placeholder',
                defaultMessage: 'Select last index',
              })}
              required
              type="number"
              marginBottom0
            />
          </Col>
        </Row>
      </>
    );
  };

  return (
    <Modal
      id="select-batch-items-modal"
      open={open}
      onClose={onClose}
      footer={renderFooter()}
      label={
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '7px',
          }}
        >
          <BiSolidSelectMultiple size={17} />
          <FormattedMessage
            id="ui-plugin-inventory-templates.selectbatchItemsModal.label"
            defaultMessage="Select batch items"
          />
        </div>
      }
      size="small"
    >
      {renderSelectBatch()}
    </Modal>
  );
}

SelectBatchModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  isFullScreen: PropTypes.bool,
  setSelectedItems: PropTypes.func,
  //   fields: PropTypes.object,
  goToIndexFunc: PropTypes.func,
};

export default SelectBatchModal;
